import { useEffect, useState } from 'react';

const useIntersectionObserver = (id: string) => {
	const [isIntersecting, setIsIntersecting] = useState(false);

	useEffect(() => {
		const elem = document.getElementById(id);
		if (!elem) {
			return;
		}

		const observer = new IntersectionObserver(
			entries => {
				const entry = entries.find(e => e.target.id === id);
				if (!entry) {
					return;
				}
				setIsIntersecting(entry.isIntersecting);
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 0.3,
			},
		);
		observer.observe(elem);

		return () => {
			observer.disconnect();
		};
	}, [id]);

	return isIntersecting;
};
export default useIntersectionObserver;
